import MiniSearch from "minisearch";

export type SearchDocument = {
	id: string;
	type: "call" | "caller" | "actionItem";
	summary?: string;
	transcript?: string;
	notes?: string;
	name?: string;
	title?: string;
};

type SearchResult = {
	id: string;
	type: SearchDocument["type"];
};

const createIndex = () =>
	new MiniSearch<SearchDocument>({
		fields: ["summary", "transcript", "notes", "name", "title"],
		storeFields: ["id", "type"],
		searchOptions: {
			prefix: true,
			fuzzy: 0.2,
		},
	});

let index = createIndex();
const documentCache = new Map<string, SearchDocument>();

export const addOrUpdateDocument = (doc: SearchDocument) => {
	const existing = documentCache.get(doc.id);
	if (existing) {
		index.remove(existing);
	}
	index.add(doc);
	documentCache.set(doc.id, doc);
};

export const removeDocument = (id: string) => {
	const existing = documentCache.get(id);
	if (!existing) {
		return;
	}
	index.remove(existing);
	documentCache.delete(id);
};

export const search = (query: string): SearchResult[] => {
	const trimmedQuery = query.trim();
	if (!trimmedQuery) {
		return [];
	}
	return index.search(trimmedQuery, {
		prefix: true,
		fuzzy: 0.2,
	}) as unknown as SearchResult[];
};

export const resetSearchIndex = () => {
	index = createIndex();
	documentCache.clear();
};
